jQuery(document).ready(function() {
	console.log("test header");
 
  
    jQuery('.icon-close, .previous-arrow, .next-arrow, .instafeed-hover-icon').attr("role","button");
    jQuery('.icon-close').attr("aria-label","close");
    jQuery('.icon-close').attr("tabindex","0");
    jQuery('#header-search').removeAttr("placeholder");
    jQuery('.go-cart__trigger.js-go-cart-trigger').attr("aria-haspopup", "dialog"); 
    jQuery('.go-cart-drawer__close').attr("aria-label", "close"); 

    jQuery('.footer-bages a:eq(0)').attr("aria-label", "cruelty free website, opens in new tab"); 
    jQuery('.footer-bages a:eq(1)').attr("aria-label", "look good feel better website, opens in new tab"); 

    jQuery('.home-hero-button').attr("aria-label", "Shop Now Meladerm"); 
    jQuery('.cta.button.parallax-button').attr("aria-label", "Shop All, opens collection page"); 

    jQuery('#section-template--21863546028267__6633e456-263c-43bf-b790-4b61edf9f127 .color-gashina.h3').attr("aria-level", "2"); 
    jQuery('#section-template--21863546028267__6633e456-263c-43bf-b790-4b61edf9f127 .color-gashina.h3').attr("role", "heading"); 

    jQuery('.h3.mb-1, .product.name.product-item-name.mb-1').attr("aria-level", "3"); 
    jQuery('.mb-3.h3, .footer-nav-header, .newsletter-heading').attr("aria-level", "2"); 

    jQuery('.visuallyhidden.d-none select').attr("aria-hidden", "true"); 
    jQuery('.button-wrapper.justify-content-center input').attr("aria-hidden", "true"); 
    jQuery('.button-wrapper.justify-content-center input').attr("tabindex", "-1"); 

    jQuery('.cart-checkmark-icon').attr("alt", ""); 
    jQuery('.col-12.col-md-4.col-lg-3').attr("role", "listitem"); 
    jQuery('.title-wrapper.h5, .h7.color-gashina.mb-1, .in-stock, .text-center.color-gashina.h3').attr("role", "heading"); 
    jQuery('.title-wrapper.h5').attr("aria-level", "3"); 
    jQuery('.icon-text.h7.text-center h6').attr("aria-level", "3"); 
    jQuery('.h7.color-gashina.mb-1').attr("aria-level", "2"); 
    jQuery('.h7.color-gashina.mb-1, .in-stock').attr("aria-level", "2"); 
    jQuery('.collapsible-heading h6, .body1.richtext-subtitle.color-gashina, .text-center.color-gashina.h3').attr("aria-level", "2"); 
    jQuery('.h5.color-gashina.mb-3').attr("aria-level", "4"); 
    jQuery('.question-heading h4').attr("aria-level", "3"); 
    jQuery('.h3.color-gashina.mb-2, .go-cart-drawer__header .h3').attr("aria-level", "2"); 
    jQuery('.h3.color-gashina.mb-2, .go-cart-drawer__header .h3').attr("role", "heading"); 

    


 

    


  

  
    
    
    jQuery('.go-cart-drawer__close, .js-click.ingredient-wrapper .circle-plus').attr({
  'role': 'button',
  'tabindex': '0'
});



	jQuery('#search-pop').attr({
  'role': 'dialog',
  'aria-modal': 'true'
});

	 
 setTimeout(function(){ 
    jQuery('#header-search').removeAttr("aria-label");
    jQuery('.fotorama__img').attr("alt", ""); 
    jQuery('svg').attr("aria-hidden", "true"); 
    jQuery('br').attr("aria-hidden", "true"); 

    jQuery('.faq-section .circle-plus').removeAttr("aria-expanded"); 
    jQuery('.faq-section .circle-plus').removeAttr("aria-label"); 
    jQuery('input[name="quantity"] input[name="quantity"]').attr('aria-label', 'Quantity');
    jQuery('.adabundle-branding a').attr("aria-label", "ada bundle website, opens in new tab"); 
    jQuery('.adabundle-branding img').attr("alt", "ada bundle logo"); 
    jQuery('.close-all-ingredients').attr("aria-label", "close all ingredients"); 
    jQuery('#junipReviewSort').attr('style', 'opacity: 0 !important;');    
    jQuery('.collapsible-heading .circle-plus').removeAttr("aria-label"); 
    jQuery('.instafeed-hover-icon').attr("role", "button"); 

    
    
     },
  3000); 


   });


//====================================================================== collapsible-heading  ==========================================================================================

document.querySelectorAll('.collapsible-heading').forEach(heading => {
  heading.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.click();
    }
  });

  heading.addEventListener('click', function() {
    const isExpanded = this.getAttribute('aria-expanded') === 'true';
    this.setAttribute('aria-expanded', !isExpanded);
  });
});

//====================================================================== scroll to top ==========================================================================================


$(window).on('scroll', function() {

  if ($(window).scrollTop() > 300) {
    $('.scroll-to-top').addClass('show');
  } else {
    $('.scroll-to-top').removeClass('show');
  }

});


$(document).on('click keydown', '.scroll-to-top', function(e) {

  if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;

  e.preventDefault();

  // Respect reduced motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    window.scrollTo(0, 0);
  } else {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

});


//====================================================================== Shop dropdown ==========================================================================================

   // ADD DROPDOWN ICON
$('nav ul.parent li.parent-with-children > a').each(function(){

    var text = $(this).text();

    // Add aria attributes
    $(this).attr({
        'aria-haspopup': 'true',
        'aria-expanded': 'false'
    });

    // Add icon
    $(this).append(
        // '<span class="dropdown-icon" aria-hidden="true"> ▼</span>'
        '<svg class="dropdown-icon" width="14" height="8" viewBox="0 0 14 8" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M1 1L7 7L13 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'

    );

});

// KEYBOARD OPEN
$('nav ul.parent li.parent-with-children > a').on('keydown', function(e){

    if (e.key === 'Enter' || e.key === ' ') {

        e.preventDefault();

        var $parent = $(this).parent();
        var $submenu = $parent.children('.js-mega-menu');
        var isOpen = $parent.hasClass('active-parent');

        // Close all first
        $('.active-megamenu').removeClass('active-megamenu');
        $('.active-parent').removeClass('active-parent');
        $('nav ul.parent li.parent-with-children > a')
          .attr('aria-expanded','false');

        if (!isOpen) {
            $submenu.addClass('active-megamenu');
            $parent.addClass('active-parent');
            $(this).attr('aria-expanded','true');
            submenuActive = true;
        }
    }
});

$(document).on('keydown', function(e){

    if (e.key === 'Escape') {

        $('.active-megamenu').removeClass('active-megamenu');
        $('.active-parent').removeClass('active-parent');

        $('nav ul.parent li.parent-with-children > a')
          .attr('aria-expanded','false');

        submenuActive = false;
    }

});

//====================================================================== Search ==========================================================================================


// Search

// Add this for keyboard support
$(document).on("keydown", ".js-show-search", function(e) {
  if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    $(this).trigger("click");
  }
});


// SEARCH ACCESSIBLE VERSION

var lastTrigger = null;

// OPEN SEARCH
$(document).on("click", ".js-show-search", function () {

    lastTrigger = $(this);

    var $modal = $('#search-pop');

    $modal.fadeIn('fast', function () {
        trapFocus($modal);
        $modal.find('input, button, [href], select, textarea')
              .filter(':visible')
              .first()
              .focus();
    });

    $(this).attr('aria-expanded', 'true');
});


// CLOSE SEARCH (click close button)
$(document).on("click", ".search-close", function () {
    closeSearch();
});


// ESC TO CLOSE
$(document).on("keydown", function (e) {
    if (e.key === "Escape" && $('#search-pop').is(':visible')) {
        closeSearch();
    }
});


function closeSearch() {

    var $modal = $('#search-pop');

    $modal.fadeOut('fast');

    $('.js-show-search').attr('aria-expanded', 'false');

    if (lastTrigger) {
        lastTrigger.focus();
    }
}


// FOCUS TRAP FUNCTION
function trapFocus($modal) {

    var focusable = $modal.find(
        'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
    ).filter(':visible');

    var first = focusable.first();
    var last = focusable.last();

    $modal.on('keydown', function (e) {

        if (e.key === "Tab") {

            if (e.shiftKey) {
                if (document.activeElement === first[0]) {
                    e.preventDefault();
                    last.focus();
                }
            } else {
                if (document.activeElement === last[0]) {
                    e.preventDefault();
                    first.focus();
                }
            }
        }

    });
}


$(document).on("click", ".icon-close", function () {
    closeSearch();
})

$(document).on("keydown", ".icon-close", function (e) {

    if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        closeSearch();
    }

});




//====================================================================== Big ID 21 contianing <main> ==========================================================================================

 
// jQuery(document).ready(function ($) {

//   // Make sure <main> exists
//   var $main = $('main');

//   if ($main.length) {

//     // List of sections you want inside <main>
//     var selectors = [
//       '#shopify-section-template--21863546028267__6633e456-263c-43bf-b790-4b61edf9f127',
//       '#shopify-section-template--21863546028267__a15d7ec6-de32-4625-a476-dcbd16c58ff2',
//       '#collection-wrap.list-collections-wrap.bg-serrafim',
//       '#collection-wrap.list-collections-wrap',
//       '#shopify-section-template--21863546028267__828778d5-3ac2-42ba-95c2-192a04d93ef3',
//       '.collection-wrap.list-collections-wrap.bg-serrafim', 
//       '.collection-wrap.list-collections-wrap '
//     ];

//     // Move each section into <main>
//     selectors.forEach(function (selector) {
//       var $section = $(selector);
//       if ($section.length) {
//         $main.append($section);
//       }
//     });

//   }

// });
 

jQuery(document).ready(function ($) {

  // ── Step 1: Check if Shopify already rendered a <main> or role="main" ──────
  // Most Shopify themes use <main id="MainContent"> — if it exists and already
  // contains the sections, nothing needs to be done at all.
  var $main = $('main, [role="main"]').first();

  var selectors = [
    '#shopify-section-template--21863546028267__6633e456-263c-43bf-b790-4b61edf9f127',
    '#shopify-section-template--21863546028267__a15d7ec6-de32-4625-a476-dcbd16c58ff2',
    '#collection-wrap.list-collections-wrap.bg-serrafim',
    '#collection-wrap.list-collections-wrap',
    '#shopify-section-template--21863546028267__828778d5-3ac2-42ba-95c2-192a04d93ef3',
    '.collection-wrap.list-collections-wrap.bg-serrafim',
    '.collection-wrap.list-collections-wrap'
  ];

  // ── Step 2: For any section already inside <main>, nothing to do ───────────
  // For any section genuinely outside a landmark, label it as a named region
  // WITHOUT moving it — preserves visual layout completely.
  selectors.forEach(function (selector) {
    var $section = $(selector);
    if (!$section.length) return;

    var alreadyInsideMain = $section.closest('main, [role="main"]').length > 0;

    if (alreadyInsideMain) {
      // ✅ Already correct — just ensure it has a role if it's a bare <div>
      if ($section.is('div') && !$section.attr('role')) {
        $section.attr('role', 'region');
      }
    } else {
      // ⚠️ Genuinely outside <main> — promote to named region landmark
      // so NVDA/VoiceOver still announces it correctly.
      // DO NOT append/move — only add ARIA attributes.
      if (!$section.attr('role')) {
        $section.attr('role', 'region');
      }

      // Label the region using its own heading if one exists
      var $heading = $section.find('h1, h2, h3').first();
      if ($heading.length && !$section.attr('aria-labelledby') && !$section.attr('aria-label')) {
        if (!$heading.attr('id')) {
          $heading.attr('id', 'region-label-' + $section.attr('id'));
        }
        $section.attr('aria-labelledby', $heading.attr('id'));
      } else if (!$section.attr('aria-label') && !$section.attr('aria-labelledby')) {
        $section.attr('aria-label', 'Page content');
      }
    }
  });

  // ── Step 3: If NO <main> landmark exists at all on the page ─────────────────
  // Promote the nearest common ancestor instead of moving children into <main>.
  if (!$main.length) {
    // Shopify common wrappers — add role="main" to whichever exists
    var $fallback = $('#MainContent, #main-content, .main-content, #content, .page-content').first();
    if ($fallback.length) {
      $fallback.attr('role', 'main');
      $fallback.attr('aria-label', 'Main content');
    }
  }

});


//====================================================================== Bug 25, + - button ==========================================================================================



jQuery(document).ready(function ($) {

  $(document).on('keydown', '.js-go-cart-quantity-plus, .js-go-cart-quantity-minus, .min, .plus', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();

      // Mark this button as the one to restore focus to
      $(this).attr('data-restore-focus', 'true');

      $(this).trigger('click');
    }
  });

});

jQuery(document).ajaxComplete(function () {

  const $restoreBtn = jQuery('[data-restore-focus="true"]');

  if ($restoreBtn.length) {
    // Remove marker
    $restoreBtn.removeAttr('data-restore-focus');

    // Restore focus
    $restoreBtn.focus();
  }

});


//====================================================================== Big Id 26  ==========================================================================================

(function ($) {
  'use strict';

  const $pdpActions = $('.pdp-actions-copy');

  // Guard: if the sticky bar is not on this page, do nothing
  if (!$pdpActions.length) return;

  // ─── Elements to hide/show inside the sticky bar ─────────────────────────────
  // Only target the specific tags you listed: a, span, button, input
  const FOCUSABLE_SELECTOR = 'a, span, button, input';

  // ─── Core: apply or remove accessibility attributes ───────────────────────────
  function setStickyAccessibility(isVisible) {
    const $elements = $pdpActions.find(FOCUSABLE_SELECTOR);

    if (isVisible) {
      // Sticky bar is on screen (top: 0) — restore everything
      $elements
        .removeAttr('aria-hidden')
        .removeAttr('tabindex');
    } else {
      // Sticky bar is off screen (top: -140px) — hide from AT and keyboard
      $elements
        .attr('aria-hidden', 'true')
        .attr('tabindex', '-1');
    }
  }

  // ─── Check inline style and apply correct state ───────────────────────────────
  function updateVisibility() {
    // Read the inline top value directly from the style attribute.
    // parseFloat handles '-140px', '-139.8px', '0px', '0' correctly.
    const topValue = parseFloat($pdpActions[0].style.top);

    // Any negative top value = off screen = hidden
    // top: 0 or no top value = on screen = visible
    const isOffScreen = topValue < 0;

    setStickyAccessibility(!isOffScreen);
  }

  // ─── MutationObserver: watch for inline style changes ────────────────────────
  // The theme animates the sticky bar by changing the inline style attribute.
  // MutationObserver fires the moment style="top: -140px" or style="top: 0"
  // is written to the DOM — more reliable than polling on scroll.
  const observer = new MutationObserver(function () {
    updateVisibility();
  });

  observer.observe($pdpActions[0], {
    attributes     : true,       // watch for attribute changes
    attributeFilter: ['style']   // only care about the style attribute
  });

  // ─── Init: set correct state on page load ─────────────────────────────────────
  updateVisibility();

}(jQuery));



//====================================================================== Big Id 28 thumnail alt   ==========================================================================================

(function ($) {
  'use strict';

  // ─── Set alt="" on all currently present fotorama images ─────────────────────
  function fixFotoramaAlt() {
    $('.fotorama__img').each(function () {
      // Only set if alt is missing entirely or not yet set
      // This avoids overwriting any meaningful alt text already present
      if ($(this).attr('alt') === undefined || $(this).attr('alt') === null) {
        $(this).attr('alt', '');
      }
    });
  }

  // ─── MutationObserver: catches lazy-loaded thumbnails as they appear ──────────
  // Fotorama injects new <img class="fotorama__img"> into the DOM
  // each time the user moves the slider. A one-time jQuery call misses these.
  function observeFotorama() {
    let debounceTimer;

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return; // ignore text nodes

          // Check if the added node itself is a fotorama image
          if ($(node).hasClass('fotorama__img')) {
            $(node).attr('alt', '');
          }

          // Check if the added node contains fotorama images as descendants
          $(node).find('.fotorama__img').each(function () {
            if ($(this).attr('alt') === undefined || $(this).attr('alt') === null) {
              $(this).attr('alt', '');
            }
          });
        });
      });
    });

    observer.observe(document.body, {
      childList : true,
      subtree   : true   // watch entire DOM tree for Fotorama's lazy injection
    });
  }

  // ─── Init ─────────────────────────────────────────────────────────────────────
  $(document).ready(function () {
    fixFotoramaAlt();    // fix images already in the DOM
    observeFotorama();   // fix images injected later by slider interaction
  });

}(jQuery));


//====================================================================== Big 31 Ingredient detials ==========================================================================================


(function ($) {
  'use strict';

  // ─── Make .circle-plus keyboard accessible ────────────────────────────────────
  function initCirclePlusAccessibility() {

    // Set aria-expanded to reflect the open/closed state on each button
    // ingredient-active class = currently open/active state
    $('.circle-plus').each(function () {
      const isActive = $(this).closest('.ingredient-wrapper').hasClass('ingredient-active');
      $(this)
        .attr('aria-expanded', isActive ? 'true' : 'false')
        // Describe what the button controls for screen readers
        .attr('aria-label', function () {
          const ingredientName = $(this)
            .closest('.ingredient-wrapper')
            .find('.title-wrapper')
            .text()
            .trim();
          return (isActive ? 'Close ' : 'Open ') + ingredientName + ' details';
        });
    });

    // ─── Keyboard: trigger same click as mouse on Enter or Space ─────────────
    $(document).off('keydown.circlePlus').on('keydown.circlePlus', '.circle-plus', function (e) {
      // Enter (13) or Space (32) should activate the button
      if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
        e.preventDefault(); // prevent Space from scrolling the page
        $(this).trigger('click');
      }
    });

    // ─── After click: update aria-expanded and aria-label to new state ────────
    // Use event delegation to catch both mouse and keyboard triggered clicks
    $(document).off('click.circlePlus').on('click.circlePlus', '.circle-plus', function () {
      const $btn     = $(this);
      const $wrapper = $btn.closest('.ingredient-wrapper');

      // Use a short delay to let the theme's own click handler run first
      // so we read the updated state (ingredient-active class) after it toggles
      setTimeout(function () {
        const isNowActive = $wrapper.hasClass('ingredient-active');
        const ingredientName = $wrapper.find('.title-wrapper').text().trim();

        $btn
          .attr('aria-expanded', isNowActive ? 'true' : 'false')
          .attr('aria-label', (isNowActive ? 'Close ' : 'Open ') + ingredientName + ' details');
      }, 50);
    });
  }

  // ─── MutationObserver: handle ingredients injected dynamically ───────────────
  // In case the ingredient grid is rendered after page load
  function observeIngredients() {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          if (
            $(node).hasClass('circle-plus') ||
            $(node).find('.circle-plus').length
          ) {
            initCirclePlusAccessibility();
          }
        });
      });
    });

    observer.observe(document.body, {
      childList : true,
      subtree   : true
    });
  }

  // ─── Init ─────────────────────────────────────────────────────────────────────
  $(document).ready(function () {
    initCirclePlusAccessibility();
    observeIngredients();
  });

}(jQuery));



//====================================================================== Bug id 33 adding sr h1 ==========================================================================================


jQuery(document).ready(function ($) {

  const path = window.location.pathname;

  // Run only on specific pages
  if (path === '/pages/about' || path === '/pages/real-stories') {

    // Prevent duplicate H1
    if ($('h1').length === 0) {

      const pageTitle = document.title;

      const $h1 = $('<h1>', {
        class: 'sr-only',
        text: pageTitle
      });

      $('main').prepend($h1);
    }
  }

});

//====================================================================== Bug ID 36 Youtube CC ==========================================================================================


jQuery(document).ready(function ($) {

  setTimeout(function () {

    const $iframe = $('.plyr__video-embed iframe');

    if (!$iframe.length) return;

    let src = $iframe.attr('src');

    function setParam(url, key, value) {
      const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
      const separator = url.includes('?') ? '&' : '?';

      if (url.match(re)) {
        return url.replace(re, `$1${key}=${value}$2`);
      } else {
        return url + separator + key + '=' + value;
      }
    }

    src = setParam(src, 'cc_load_policy', '1');
    src = setParam(src, 'controls', '1');
    src = setParam(src, 'disablekb', '0');
    src = setParam(src, 'cc_lang_pref', 'en');

    $iframe.attr('src', src);

  }, 3000); // ⏱ 3 seconds delay

});

//====================================================================== Bug ID 41 FAQs   ==========================================================================================
/*
document.querySelectorAll('.question-heading[role="button"]').forEach(heading => {
  heading.addEventListener('click', toggleFAQ);
  
  heading.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault(); // prevents page scroll on Space
      toggleFAQ.call(heading, e);
    }
  });
});

function toggleFAQ() {
  const expanded = this.getAttribute('aria-expanded') === 'true';
  this.setAttribute('aria-expanded', String(!expanded));

  // target the answer panel — the next sibling
  const answer = this.closest('.question').querySelector('.answer');
  if (answer) {
    answer.style.display = expanded ? 'none' : 'block';
  }
}
*/

 /* fix for above script to display on mobile */
 /*
document.querySelectorAll('.question-heading[role="button"]').forEach(heading => {
  heading.addEventListener('click', toggleFAQ);
  
  heading.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault(); 
      toggleFAQ(e); 
    }
  });
});

function toggleFAQ(e) {
  // Forces the browser to ignore any other scripts trying to intercept this click
  e.stopImmediatePropagation();
  e.preventDefault();
  
  const heading = e.currentTarget;
  const expanded = heading.getAttribute('aria-expanded') === 'true';
  
  // Toggle aria state
  heading.setAttribute('aria-expanded', String(!expanded));

  // Find the answer panel
  const answer = heading.closest('.question').querySelector('.answer');
  if (answer) {
    // Force the style change explicitly
    answer.style.setProperty('display', expanded ? 'none' : 'block', 'important');
  }
}
*/
//====================================================================== Mobile menu opening ==========================================================================================

// const hamburger = document.querySelector('.js-hamburger');
// const mobileNav = document.querySelector('.mobile-nav');
// const closeBtn = document.querySelector('.js-mobile-close'); // add this


// hamburger.addEventListener('keydown', (e) => {
//   if (e.key === 'Enter' || e.key === ' ') {
//     e.preventDefault();
//     toggleMenu();
//   }
// });

// closeBtn.addEventListener('click', toggleMenu); // add this

// function toggleMenu() {
//   document.body.classList.toggle('mobile-nav-active');
//   const isOpen = document.body.classList.contains('mobile-nav-active');

//   hamburger.setAttribute('aria-expanded', String(isOpen));
//   hamburger.setAttribute('aria-label', isOpen ? 'close menu' : 'open menu');
//   mobileNav.setAttribute('aria-hidden', String(!isOpen));

//   if (isOpen) {
//     openMenu();
//   } else {
//     closeMenu();
//   }
// }

// function getFocusableElements() {
//   return Array.from(
//     mobileNav.querySelectorAll(
//       'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
//     )
//   ).filter(el => !el.hasAttribute('disabled') && el.offsetParent !== null);
// }

// function trapFocus(e) {
//   const focusable = getFocusableElements();
//   const first = focusable[0];
//   const last = focusable[focusable.length - 1];

//   if (e.key === 'Escape') {
//     toggleMenu();
//     return;
//   }

//   if (e.key === 'Tab') {
//     if (focusable.length === 0) {
//       e.preventDefault();
//       return;
//     }
//     if (e.shiftKey) {
//       if (document.activeElement === first) {
//         e.preventDefault();
//         last.focus();
//       }
//     } else {
//       if (document.activeElement === last) {
//         e.preventDefault();
//         first.focus();
//       }
//     }
//   }
// }

// function openMenu() {
//   // focus the close button first so user is immediately inside the menu
//   closeBtn.focus();
//   document.addEventListener('keydown', trapFocus);
// }

// function closeMenu() {
//   document.removeEventListener('keydown', trapFocus);
//   hamburger.focus();
// }


const hamburger = document.querySelector('.js-hamburger');
const mobileNav = document.querySelector('.mobile-nav');
var toggleInProgress = false;

// ── Remove any existing click listeners from theme code ───────────────────────
const freshHamburger = hamburger.cloneNode(true); // cloneNode strips all listeners
hamburger.parentNode.replaceChild(freshHamburger, hamburger);
const cleanHamburger = document.querySelector('.js-hamburger'); // re-query after replace

// ── Attach fresh listeners ────────────────────────────────────────────────────
cleanHamburger.addEventListener('click', toggleMenu);

cleanHamburger.addEventListener('keydown', (e) => {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    toggleMenu();
  }
});

function toggleMenu() {
  if (toggleInProgress) return;
  toggleInProgress = true;
  setTimeout(() => { toggleInProgress = false; }, 50);

  const isOpen = document.body.classList.toggle('mobile-nav-active');

  cleanHamburger.setAttribute('aria-expanded', String(isOpen));
  cleanHamburger.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
  mobileNav.setAttribute('aria-hidden', String(!isOpen));

  // const hamburgerSVG = `
  //   <svg width="30" height="21" viewBox="0 0 30 21" fill="none"
  //        xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  //     <line x1="0.90625" y1="1.44922"  x2="29.0105" y2="1.44922"  stroke="white" stroke-width="1.5" stroke-linecap="round"></line>
  //     <line x1="0.90625" y1="10.4492"  x2="29.0105" y2="10.4492"  stroke="white" stroke-width="1.5" stroke-linecap="round"></line>
  //     <line x1="0.90625" y1="19.4492"  x2="29.0105" y2="19.4492"  stroke="white" stroke-width="1.5" stroke-linecap="round"></line>
  //   </svg>`;

  // const closeSVG = `
  //   <svg width="30" height="30" viewBox="0 0 30 30" fill="none"
  //        xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  //     <line x1="2"  y1="2"  x2="28" y2="28" stroke="white" stroke-width="1.5" stroke-linecap="round"></line>
  //     <line x1="28" y1="2"  x2="2"  y2="28" stroke="white" stroke-width="1.5" stroke-linecap="round"></line>
  //   </svg>`;

  // cleanHamburger.innerHTML = isOpen ? closeSVG : hamburgerSVG;

  const lines = cleanHamburger.querySelectorAll('svg line');
  lines.forEach(line => line.classList.toggle('x', isOpen));
  
  isOpen ? openMenu() : closeMenu();
}

function getFocusableElements() {
  return Array.from(
    mobileNav.querySelectorAll(
      'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
    )
  ).filter(el => !el.hasAttribute('disabled') && el.offsetParent !== null);
}

function trapFocus(e) {
  const focusable = getFocusableElements();
  const first = focusable[0];
  const last  = focusable[focusable.length - 1];

  if (e.key === 'Escape') { toggleMenu(); return; }

  if (e.key === 'Tab') {
    if (focusable.length === 0) { e.preventDefault(); return; }
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
    }
  }
}

function openMenu() {
  document.addEventListener('keydown', trapFocus);
  const focusable = getFocusableElements();
  if (focusable.length) focusable[0].focus();
}

function closeMenu() {
  document.removeEventListener('keydown', trapFocus);
  cleanHamburger.focus();
}



//====================================================================== Cart slider code NEW 2-Mar-26 ==========================================================================================


// (function () {
//   const FOCUSABLE_SELECTORS = [
//     'a[href]',
//     'button:not([disabled])',
//     'input:not([disabled])',
//     '[tabindex]:not([tabindex="-1"])',
//     '[role="button"]'
//   ].join(', ');

//   const trigger = document.querySelector('.js-go-cart-trigger');
//   const drawer = document.querySelector('.js-go-cart-drawer');
//   const closeBtn = document.querySelector('.js-go-cart-drawer-close');

//   let lastFocusedElement = null;

//   // ── Helper: get all focusable elements inside the drawer ──
//   function getFocusableElements() {
//     return [...drawer.querySelectorAll(FOCUSABLE_SELECTORS)].filter(
//       el => !el.closest('[hidden]') && el.offsetParent !== null
//     );
//   }

//   // ── Open drawer ──
//   function openDrawer(returnTarget) {
//     // Only store activeElement if no explicit return target was passed
//     lastFocusedElement = returnTarget || document.activeElement;

//     drawer.classList.add('is-open');
//     document.body.style.overflow = 'hidden'; // prevent background scroll
//     drawer.removeAttribute('aria-hidden');
//     drawer.setAttribute('role', 'dialog');
//     drawer.setAttribute('aria-modal', 'true');
//     drawer.setAttribute('aria-label', 'Shopping cart');

//     requestAnimationFrame(() => {
//       const firstItem = drawer.querySelector('.go-cart-item__info-wrapper a, .go-cart-item__info-wrapper, .go-cart-drawer__close');
//       if (firstItem) {
//         if (!firstItem.hasAttribute('tabindex')) firstItem.setAttribute('tabindex', '-1');
//         firstItem.focus();
//       } else {
//         const focusable = getFocusableElements();
//         if (focusable.length) focusable[0].focus();
//       }
//     });

//     document.addEventListener('keydown', handleKeyDown);
//   }

//   // ── Close drawer ──
//   function closeDrawer() {
//     drawer.classList.remove('is-open');
//     drawer.setAttribute('aria-hidden', 'true');
//     document.body.style.overflow = ''; // restore background scroll
//     // Remove overlay open state
//     const overlay = document.querySelector('.js-go-cart-overlay');
//     if (overlay) overlay.classList.remove('is-open');

//     document.removeEventListener('keydown', handleKeyDown);

//     if (lastFocusedElement) {
//       lastFocusedElement.focus();
//       lastFocusedElement = null;
//     }
//   }

//   // ── Trap focus & handle Escape ──
//   function handleKeyDown(e) {
//     if (e.key === 'Escape') {
//       e.preventDefault();
//       closeDrawer();
//       return;
//     }

//     if (e.key === 'Tab') {
//       const focusable = getFocusableElements();
//       if (!focusable.length) return;

//       const first = focusable[0];
//       const last = focusable[focusable.length - 1];

//       if (e.shiftKey) {
//         if (document.activeElement === first || document.activeElement === drawer.querySelector('.go-cart-item__info-wrapper')) {
//           e.preventDefault();
//           last.focus();
//         }
//       } else {
//         if (document.activeElement === last) {
//           e.preventDefault();
//           first.focus();
//         }
//       }
//     }
//   }

//   // ── Trigger: click or Enter/Space ──
//   trigger.addEventListener('click', openDrawer);
//   trigger.addEventListener('keydown', (e) => {
//     if (e.key === 'Enter' || e.key === ' ') {
//       e.preventDefault();
//       openDrawer();
//     }
//   });

//   // ── Close button ──
//   closeBtn.addEventListener('click', closeDrawer);
//   closeBtn.addEventListener('keydown', (e) => {
//     if (e.key === 'Enter' || e.key === ' ') {
//       e.preventDefault();
//       closeDrawer();
//     }
//   });

//   // ── Add to Cart buttons — open drawer and return focus to button on close ──
//   document.querySelectorAll('.js-go-cart-add-to-cart').forEach(btn => {
//     btn.addEventListener('click', () => {
//       setTimeout(() => {
//         openDrawer(btn); // pass button as explicit return target
//       }, 100);
//     });
//   });

//   // ── Click outside drawer to close ──
//   document.addEventListener('click', (e) => {
//     if (
//       drawer.classList.contains('is-open') &&
//       !drawer.contains(e.target) &&
//       !trigger.contains(e.target)
//     ) {
//       closeDrawer();
//     }
//   });
// })();

(function () {
  const FOCUSABLE_SELECTORS = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
    '[role="button"]',
    '.go-cart-drawer__close'
  ].join(', ');

  const trigger = document.querySelector('.js-go-cart-trigger');
  const drawer = document.querySelector('.js-go-cart-drawer');
  const closeBtn = document.querySelector('.js-go-cart-drawer-close');

  let lastFocusedElement = null;

  function getFocusableElements() {
    return [...drawer.querySelectorAll(FOCUSABLE_SELECTORS)].filter(
      el => !el.closest('[hidden]') && el.offsetParent !== null
    );
  }

  // ── Only handle focus, ARIA, and key trap — let site JS handle open state ──
  function onDrawerOpened(returnTarget) {
    // lastFocusedElement = returnTarget || document.activeElement;

      if (!lastFocusedElement) {
      lastFocusedElement = returnTarget || document.activeElement;
    }

    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'Shopping cart');
    drawer.removeAttribute('aria-hidden');

    // Show overlay immediately — no delay
    const overlay = document.querySelector('.js-go-cart-overlay');
    if (overlay) overlay.classList.add('is-open');

    // Wait for site's animation + cart render to complete
    setTimeout(() => {
      const firstItem = drawer.querySelector('.go-cart-item__info-wrapper a, .go-cart-item__info-wrapper, .go-cart-drawer__close');
      if (firstItem) {
        if (!firstItem.hasAttribute('tabindex')) firstItem.setAttribute('tabindex', '-1');
        firstItem.focus();
      } else {
        const focusable = getFocusableElements();
        if (focusable.length) focusable[0].focus();
      }
    }, 300); // matches typical slide-in animation duration

    document.addEventListener('keydown', handleKeyDown);
  }

  function onDrawerClosed() {
    drawer.setAttribute('aria-hidden', 'true');

    // Hide overlay immediately on close
    const overlay = document.querySelector('.js-go-cart-overlay');
    if (overlay) overlay.classList.remove('is-open');

    document.removeEventListener('keydown', handleKeyDown);

    if (lastFocusedElement) {
      lastFocusedElement.focus();
      lastFocusedElement = null;
    }
  }

  // ── Observe drawer for is-open class changes by site's own JS ──
  const observer = new MutationObserver(() => {
    if (drawer.classList.contains('is-open')) {
      onDrawerOpened(lastFocusedElement);
    } else {
      onDrawerClosed();
    }
  });

  observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });

  // ── Trigger: keyboard only (click is already handled by site JS) ──
  trigger.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      lastFocusedElement = trigger;
      trigger.click(); // let site JS do the actual opening
    }
  });

  // ── Close via Escape or close button keyboard ──
  function handleKeyDown(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      closeBtn.click(); // let site JS handle closing
      return;
    }

    if (e.key === 'Tab') {
      const focusable = getFocusableElements();
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey) {
        if (
          // document.activeElement === first ||
          // document.activeElement === drawer.querySelector('.go-cart-item__info-wrapper')
          !drawer.contains(document.activeElement) || document.activeElement === first
        ) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
  }

  closeBtn.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      closeBtn.click();
    }
  });

  // ── Add to Cart buttons ──
  document.querySelectorAll('.js-go-cart-add-to-cart').forEach(btn => {
    btn.addEventListener('click', () => {
      lastFocusedElement = btn;
      // Site JS opens drawer — MutationObserver picks it up
      // Extra delay for cart items to render
      setTimeout(() => {
        if (drawer.classList.contains('is-open')) {
          onDrawerOpened(btn);
        }
      }, 500);
    });
  });

})();





//====================================================================== Remove button function ==========================================================================================

$(document).on('keydown', '.go-cart-item__remove', function (e) {

  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    this.click();    
  }

});


$(document).on('click', '.go-cart-item__remove', function () {
  $('#remove-cart-live').text('Item removed from cart');
});



//====================================================================== PLAY/PASUE SLIDER LOGO ==========================================================================================

$(document).on('click keydown', '.as-seen-toggle', function (e) {

  if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;

  e.preventDefault();

  var $btn = $(this);
  var $track = $('.as-seen-track');

  var isPaused = $track.hasClass('paused');

  if (isPaused) {

    $track.removeClass('paused');
    $btn.text('Pause');
    $btn.attr({
      'aria-pressed': 'false',
      'aria-label': 'Pause brand slider'
    });

  } else {

    $track.addClass('paused');
    $btn.text('Play');
    $btn.attr({
      'aria-pressed': 'true',
      'aria-label': 'Play brand slider'
    });

  }

});


//====================================================================== Cart New slider code ==========================================================================================


// Cart slider

// var lastCartTrigger = null;
// var $cartDrawer = $('.go-cart__drawer');
// var $cartTrigger = $('.js-go-cart-trigger');

// // Add ARIA to drawer
// $cartDrawer.attr({
//   'role': 'dialog',
//   'aria-modal': 'true'
// });

// // Add aria-expanded to trigger
// $cartTrigger.attr({
//   'aria-expanded': 'false',
//   'aria-controls': 'cart-drawer'
// });

// // Give drawer an ID if not present
// if (!$cartDrawer.attr('id')) {
//   $cartDrawer.attr('id', 'cart-drawer');
// }


// // OPEN WITH ENTER / SPACE
// $(document).on('keydown', '.go-cart__trigger.js-go-cart-trigger', function(e) {

//   if (e.key === 'Enter' || e.key === ' ') {
//     e.preventDefault();
//     $(this).trigger('click');
//   }

// });


// // WHEN CART OPENS (detect class change)
// var cartObserver = new MutationObserver(function() {

//   if ($cartDrawer.hasClass('is-open')) {

//     lastCartTrigger = $cartTrigger;

//     $cartTrigger.attr('aria-expanded', 'true');

//     setTimeout(function() {

//       trapCartFocus($cartDrawer);

//       $cartDrawer
//         .find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])')
//         .filter(':visible')
//         .first()
//         .focus();

//     }, 2000);

//   }

// });

// cartObserver.observe($cartDrawer[0], {
//   attributes: true,
//   attributeFilter: ['class']
// });


// // ESC CLOSE
// $(document).on('keydown', function(e) {

//   if (e.key === 'Escape' && $cartDrawer.hasClass('is-open')) {

//     closeCart();

//   }

// });


// function closeCart() {

//   $cartDrawer.removeClass('is-open');
//   $cartTrigger.attr('aria-expanded', 'false');

//   if (lastCartTrigger) {
//     lastCartTrigger.focus();
//   }

// }


// // FOCUS TRAP
// function trapCartFocus($modal) {

//   var focusable = $modal.find(
//     'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
//   ).filter(':visible');

//   var first = focusable.first();
//   var last = focusable.last();

//   $modal.on('keydown.cartTrap', function(e) {

//     if (e.key === 'Tab') {

//       if (e.shiftKey) {

//         if (document.activeElement === first[0]) {
//           e.preventDefault();
//           last.focus();
//         }

//       } else {

//         if (document.activeElement === last[0]) {
//           e.preventDefault();
//           first.focus();
//         }

//       }

//     }

//   });

// }



//============================== Screen reader annoucing menu items even it is closed //==============================


jQuery(document).ready(function ($) {

  var MOBILE_BREAKPOINT = 988;

  function handleMobileNavVisibility() {
    var $mobileNav = $('.mobile-nav.d-flex');

    if (!$mobileNav.length) return;

    if ($(window).width() <= MOBILE_BREAKPOINT) {
      var isOpen = document.body.classList.contains('mobile-nav-active');

      // ── When closed: completely hidden from SR and keyboard ────────────────
      if (!isOpen) {
        $mobileNav.attr('aria-hidden', 'true');
        $mobileNav.attr('tabindex', '-1');

        // Make all focusable children unreachable by keyboard and SR
        $mobileNav.find(
          'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
        ).attr('tabindex', '-1').attr('data-sr-hidden', 'true');

      } else {
        // ── When open: fully accessible ──────────────────────────────────────
        $mobileNav.attr('aria-hidden', 'false');
        $mobileNav.removeAttr('tabindex');

        // Restore all focusable children
        $mobileNav.find('[data-sr-hidden="true"]')
          .attr('tabindex', '0')
          .removeAttr('data-sr-hidden');
      }

    } else {
      // ── Desktop: remove all mobile SR restrictions ─────────────────────────
      $mobileNav.removeAttr('aria-hidden');
      $mobileNav.removeAttr('tabindex');

      $mobileNav.find('[data-sr-hidden="true"]')
        .attr('tabindex', '0')
        .removeAttr('data-sr-hidden');
    }
  }

  // ── Run on page load ───────────────────────────────────────────────────────
  handleMobileNavVisibility();

  // ── Run on window resize ───────────────────────────────────────────────────
  $(window).on('resize', function () {
    handleMobileNavVisibility();
  });

  // ── Run whenever toggleMenu fires (open/close) ─────────────────────────────
  // Observe body class change — works with your existing toggleMenu function
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === 'class') {
        handleMobileNavVisibility();
      }
    });
  });

  observer.observe(document.body, { attributes: true });

});


